

export class StringUtil {
      replaceSpaceWith_(str: string): string {
            return str.split(' ').join('_');
      }
}
